var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm._f("formattedDate")(_vm.item.createdAt)))]),_c('td',[_vm._v(_vm._s(_vm.item.title))]),_c('td',{staticClass:"text-xs-right justify-center px-0 actions"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }